.ux-iws-locale-selection-banner {
    display: block;
    position: relative;
    height: 0;
    transition: height $animationSpeed-normal $animationEasing-easeInOut;
    overflow: hidden;
    max-width: 1920px;
    margin: 0 auto;
    background-color: $color-gray-background-dark;
    padding: 0;

    &__content-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        padding: 25px 35px;

        @media only screen and (min-width: 1024px) {
            padding: 10px 20px;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
    }

    &__description-text {
        @include font(light);
        font-size: $size-text-small;
        color: $color-gray-text;
        text-align: center;
        padding: 0 0 20px;
        flex: 1 1 auto;

        @media only screen and (min-width: 768px) {
            padding: 0 10px 20px;
        }

        @media only screen and (min-width: 1024px) {
            padding: 0 10px;
        }
    }

    &__select-container {
        margin-bottom: 20px;
        flex-shrink: 0;

        @media only screen and (min-width: 1024px) {
            margin-bottom: 0;
            margin-right: 30px;
            margin-left: 10px;
        }
    }

    &__close-container {
        cursor: pointer;
        background-color: transparent;
        border: 0;
        outline: 0;

        @media only screen and (max-width: 1023px) {
            position: absolute;
            top: 5px;
            right: 8px;
        }

        @media only screen and (min-width: 1024px) {
            margin-left: 20px;
        }
    }

    ux-select:not(.hydrated) {
        display: block;
        height: 44px;
        max-height: 44px;
        overflow: hidden;
    }
}
